<template>
  <v-dialog
    :value="value"
    @input="$emit('input', $event)"
    width="550"
    persistent
    overlay-class="custom-dialog-overlay"
    content-class="custom-dialog-content"
    :z-index="9999"
    attach
  >
    <v-card class="index-page pa-4 pa-sm-8 d-flex flex-column justify-center">
      <v-row no-gutters justify="center" align="center">
        
        <v-col cols="12" class="text-center mb-4">
          <span class="text-title">คุณได้รับสิทธิ์ใช้งานฟรี</span>
        </v-col>

        <v-col cols="12" class="d-flex justify-center mb-4">
          <v-img src="@/assets/free_package.png" max-height="260px" contain />
        </v-col>

        <v-col cols="12" class="text-center mb-2">
          <div class="text-theme-color font-weight-bold">
            {{ packageName }}
          </div>
        </v-col>

        <v-col cols="12" class="text-center mb-6">
          <div class="text-subtitle">
            สามารถกดยืนยันเพื่อเริ่มใช้งานได้ทันที
            
          </div>
        </v-col>

        <v-col cols="12">
          <v-row no-gutters justify="center">
            <v-btn
              color="default_button_primary"
              class="btn-submit mr-2"
              outlined
              @click="$emit('close')"
              :disabled="loading"
            >
              รับสิทธิ์ภายหลัง
            </v-btn>

            <v-btn
              color="default_button_primary"
              class="btn-submit ml-2"
              dark
              @click="$emit('confirm')"
              :loading="loading"
            >
              ยืนยันรับสิทธิ์
            </v-btn>
          </v-row>
        </v-col>

      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DialogFreePackage",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    packageName: {
      type: String,
      // ใส่ค่า Default สำหรับทดสอบ
      default: "คุณได้รับสิทธิ์ ค้นหา Resume 30 Credit ฟรี 3 เดือน",
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
   computed: {
    surveyImage() {
      return process.env.VUE_APP_USE_THEME === "SPU_ADMIN"
        ? require("@/assets/survey 1_0_SPU.png")
        : require("@/assets/survey 1_0.png");
    },
  },
};
</script>


<style scoped>
.index-page {
  border-radius: 18px !important;
  font-family: 'Noto Sans Thai' !important;
  /* ใช้ min-height แทน height ตายตัว เพื่อให้เนื้อหาจัดกลางได้ยืดหยุ่น */
  min-height: 590px;
}

.btn-submit {
  border-radius: 16px;
  background-color: var(--v-theme_primary) !important;
}

.text-title {
  color: #333333;
  font-size: 22px; /* เพิ่มขนาดหัวข้อเล็กน้อย */
  line-height: 1.5;
  font-weight: 700;
}

.text-theme-color {
  color: var(--v-default_button_primary-base) !important;
  font-size: 18px;
}

.text-subtitle {
  color: #666666;
  font-size: 16px;
}

/* ปรับแต่ง Dialog */
::v-deep .v-dialog {
  border-radius: 18px !important;
  overflow-y: hidden; /* กัน Scrollbar เกินจำเป็น */
}
</style>